{
  "customer_groups_page": {
    "header": {
      "title": "Customer groups",
      "description": "Set up specific ordering rules for your B2B customers.",
      "actions": {
        "create": "Create customer group"
      }
    },
    "additional_customer_groups_card": {
      "header": "Additional customer groups",
      "description": "Customer groups that inherit from your base."
    },
    "help_cards": {
      "header": "More ways to manage your B2B customers",
      "invite_customers": {
        "title": "Set up sales agents",
        "description": "Let your sales agents place orders and manage accounts on behalf of your B2B customers.",
        "action": "Manage sales agents"
      },
      "international": {
        "title": "View all your B2B customers",
        "description": "See every customer who can place B2B orders, their group, and their assigned rules - all in one place.",
        "action": "View customers"
      }
    },
    "footer": {
      "description": "Learn more about customer groups"
    }
  },
  "customer_groups_quick_setup_page": {
    "header": {
      "title": "Create customer group",
      "description": "Set up the essentials for this customer group. Advanced settings like stock locations, checkout rules, and display options can be added anytime by editing the group.",
      "actions": {
        "switch_to_advanced": "Advanced setup"
      }
    },
    "view_price_lists": "View price lists",
    "alert": {
      "title": "Want more options?",
      "message": "Need checkout settings, stock settings, or address settings? Switch to advanced setup - nothing you enter here is lost.",
      "switch_to_advanced": "Switch to advanced setup"
    },
    "notifications": {
      "success": {
        "create_succeeded": "Customer group created successfully."
      }
    }
  },
  "customer_group_builder_page": {
    "header": {
      "title": {
        "create": "Create customer group",
        "edit": "Edit customer group"
      },
      "description": "Configure how you want your customer group to work.",
      "actions": {
        "create": "Create customer group",
        "update": "Update customer group"
      }
    },
    "more_actions": {
      "view": "View tagged customers",
      "delete": "Delete",
      "switch_to_quick_setup": "Quick setup"
    },
    "notifications": {
      "errors": {
        "delete_failed": "Failed to delete customer group.",
        "no_unique_id": "Please ensure the handle (ID) is unique across customer groups.",
        "invalid_char": "Please ensure the input format is valid.",
        "invalid_id": "Please ensure the handle (ID) isn't \"default\" and doesn't start with a dash (\"-\")."
      },
      "success": {
        "create_succeeded": "Customer group \"{name}\" successfully created.",
        "update_succeeded": "Customer group \"{name}\" successfully updated."
      }
    }
  }
}
